<template>
  <div class="store-skeleton">
    <SkeletonAnimation>
      <PartItem :styles="banner"></PartItem>
    </SkeletonAnimation>

    <div class="store-info">
      <div class="max-width store-flex">
        <SkeletonAnimation>
          <div class="common-flex">
            <!-- <div class="common-flex_left"></div> -->
            <div class="common-flex_right">
              <PartItem
                :styles="{
                  width: '578px',
                  height: '20px',
                  'border-radius': '4px',
                  'margin-bottom': '20px',
                }"
              ></PartItem>
              <PartItem
                :styles="{
                  width: '400px',
                  height: '20px',
                  'border-radius': '4px',
                }"
              ></PartItem>
            </div>
          </div>
        </SkeletonAnimation>
      </div>
    </div>
    <div class="store-content">
      <SkeletonAnimation>
        <div class="store-content__infos max-width">
          <div class="common-left">
            <div class="store-info__sku">
              <PartItem
                v-for="item in 4"
                :key="item"
                :styles="{
                  width: '155px',
                  height: '20px',
                  'border-radius': '4px',
                  'margin-bottom': '28px',
                }"
              ></PartItem>
            </div>
          </div>
          <div class="common-right">
            <div class="common-right_title">
              <PartItem
                :key="item"
                :styles="{
                  width: '182px',
                  height: '20px',
                  'border-radius': '4px',
                  'margin-bottom': '20px',
                }"
              ></PartItem>
            </div>
            <Store1></Store1>
            <Store1></Store1>
            <Store1></Store1>
            <Store1></Store1>
            <Store1></Store1>
            <Store1></Store1>
            <Store1></Store1>
            <Store1></Store1>
            <Store1></Store1>
          </div>
        </div>
      </SkeletonAnimation>
    </div>
  </div>
</template>
<script>
import SkeletonAnimation from '../../SkeletonAnimation';
import PartItem from '../partItem.vue';
import Store1 from '../store1.vue';
export default {
  name: 'StoreSkeletonPc',
  components: {
    SkeletonAnimation,
    PartItem,
    Store1,
  },
  data() {
    return {
      banner: {
        width: '100%',
        height: '221px',
        'border-radius': '0',
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.max-width {
  max-width: 1156px;
  margin: 0 auto;
}
.store-info {
  height: 106px;
  padding: 24px 0;
  background: #fff;
}
.mb-20 {
  margin-bottom: 20px;
}
.mb-60 {
  margin-bottom: 60px;
}

.store-content {
  background: #f5f5f7;
  padding-bottom: 70px;
  padding-top: 40px;
  .store-content__infos {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
}

.common-left {
  width: 195px;
}
.common-right {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  .store-item {
    margin-right: 20px;
  }
  .store-item:nth-child(3n+1) {
    margin-right: 0px;
  }
}
.common-right_title {
  width: 100%;
}
.common-flex{
  display: flex;
  align-items: center;
  position: relative;
  .common-flex_left{
    width: 140px;
    height: 140px;
    position: absolute;
    top: -20px;
    border-radius: 8px;
    background: #E5E5EB;
  }
}
</style>
